"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _reactredux = require('react-redux');






 const useAppSelector = _reactredux.useSelector.withTypes(); exports.useAppSelector = useAppSelector
 const useAppDispatch = _reactredux.useDispatch.withTypes(); exports.useAppDispatch = useAppDispatch
